import React from "react";
import { green } from "@mui/material/colors";
import HubRoundedIcon from "@mui/icons-material/HubRounded";
import GenericSupportListing from "../GenericSupportListing/GenericSupportListing";

// ===================== CONSTANTS =====================
const PAGE_TITLE = "Regulatory Ingredients Hub";
const API_ENDPOINT = "/support-requests/hub";

const RequestsHubPage = () => {
  return (
    <GenericSupportListing
      pageTitle={PAGE_TITLE}
      apiRoute={API_ENDPOINT}
      showResponseAction={false}
      showViewAction={true}
      PageIcon={<HubRoundedIcon color="white" fontSize="large" />}
      iconColor={green[700]}
    />
  );
};

export default RequestsHubPage;
